import { useStoreActions, useStoreState } from '../../../../store/hooks'
import { Notations } from '../../components/Notations'

const PuzzlePracticeNotations: React.FC = () => {
    const gameTree = useStoreState((state) => state.puzzlePracticeView.gameTree)
    const notations = useStoreState((state) => state.puzzlePracticeView.notations)
    const showSolution = useStoreState((state) => state.puzzlePracticeView.showSolution)
    const puzzleState = useStoreState((state) => state.puzzlePracticeView.puzzleState)
    const currentPosition = useStoreState((state) => state.puzzlePracticeView.currentPosition)

    const setCurrentPosition = useStoreActions((state) => state.puzzlePracticeView.setCurrentPosition)

    return (
        <Notations
            notations={notations}
            gameTree={gameTree}
            currentPosition={currentPosition}
            setCurrentPosition={setCurrentPosition}
            disabled={notations.length <= 1 || (showSolution && puzzleState === null)}
        />
    )
}

export default PuzzlePracticeNotations
